import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import Swal from 'sweetalert2';
import { RequestStatusContractFui } from '../../account/models/RequestStatusContractFui';
import { SupplierService } from '../services/supplier.service';
import { filter } from 'rxjs/operators';
import * as moment from 'moment/moment';

@Component({
  selector: 'app-terminate-contract',
  templateUrl: './terminate-contract.component.html',
  styleUrls: ['./terminate-contract.component.scss']
})
export class TerminateContractComponent implements OnInit {

  public terminateContractForm: FormGroup;
  public contract: any;
  public saveButtonText = 'Salveaza';
  public startDate: string = 'Data efectiva reziliere';
  public number: string = 'Numar';
  public client: string = 'Client';
  public identificationNumber: string = 'CUI / CNP / Numar identificare';
  public reason: string = 'Motiv';
  public minDate: Date;
  public isTerminateContractSubmitAttempt: boolean = false;
  private type: string;
  public renouncementMessage: string;
  public reasonTypeLabel: string = 'Tip reziliere';
  public reasonTypeOptions: Map<string, string>;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private formBuilder: FormBuilder,
    private supplierService: SupplierService
  ) {
    this.reasonTypeOptions = new Map<string, string>([
      ['ANULARE_CERERE_CONTRACTARE', 'ANULARE CERERE CONTRACTARE'],
      ['DENUNTARE', 'DENUNTARE'],
      ['DENUNTARE_INCETARE_LOC', 'DENUNTARE INCETARE LOC'],
      ['REZILIERE', 'REZILIERE'],
      ['REZILIERE_NEPLATA', 'REZILIERE NEPLATA'],
      ['ACORDUL_PARTILOR', 'ACORDUL PARTILOR'],
      ['EROARE_MATERIALA', 'EROARE MATERIALA']
    ]);
    this.minDate = new Date();
    this.minDate.setDate(this.minDate.getDate());
    this.contract = JSON.parse(localStorage.getItem('contract'));
    this.iniTerminateContractForm();
  }

  ngOnInit(): void {
    this.route.queryParams
      .pipe(
        filter(params => params.tip)
      )
      .subscribe(params => {
        this.type = params.tip;
      }
      );
  }

  iniTerminateContractForm(): void {
    this.terminateContractForm = this.formBuilder.group({
      identificationNumber: new FormControl({ value: this.contract.clientCode, disabled: true }),
      client: new FormControl({ value: this.contract.client, disabled: true }),
      number: new FormControl({ value: this.contract.number, disabled: true }),
      startDate: new FormControl('', Validators.required),
      reason: new FormControl('', Validators.required),
      reasonType: new FormControl('', Validators.required)
    });
  }

  onCancelContract(): void {
    this.isTerminateContractSubmitAttempt = true;
    if (!this.terminateContractForm.valid) {
      Swal.fire({
        html: `Va rugam sa completati toate campurile`,
        showConfirmButton: true,
        confirmButtonText: 'Ok',
        customClass: {
          popup: 'popup-z-elevate-24-blue'
        }
      });
      return;
    }

    const requestStatusContractFui: RequestStatusContractFui = {
      statusChangeReason: this.terminateContractForm.get('reason').value,
      statusChangeDate: this.terminateContractForm.get('startDate').value,
      statusChangeReasonType: this.terminateContractForm.get('reasonType').value
    };

    this.supplierService.cancelContract(this.contract.id, requestStatusContractFui).subscribe(e => {
      return this.router.navigateByUrl('/furnizor/' + this.type);
    });
  }

  onDisplayRequiredField(field: string): any {
    return {
      'input-required': !this.isFieldValid(field) && this.isTerminateContractSubmitAttempt,
    };
  }

  isFieldValid(field: string): boolean {
    return this.terminateContractForm.get(field).valid;
  }

  onCancel(): void {
    history.back();
  }

  checkStartDate(): void {
    this.renouncementMessage = '';
    const reziliationStartingDate = this.terminateContractForm.get('startDate').value && moment(this.terminateContractForm.get('startDate').value);
    const contractStartingDate = this.contract.contractStartingDate && moment(this.contract.contractStartingDate);
    if (this.contract.status === 'ACTIV (neintrat in vigoare)' && reziliationStartingDate) {
      const days = reziliationStartingDate.diff(this.contract.contractDate, 'days');
      const days2 = contractStartingDate.diff(this.contract.contractDate, 'days');
      this.renouncementMessage += 'Nota: Rezilierea se realizeaza dupa ' + days + ' zile de la semnarea contractului. ';
      if (days > 14) {
        this.renouncementMessage += 'Rezilierea contractului nu va reactiva contractul vechi deoarece rezilierea este peste 14 zile de la data semnarii.';
      } else {
        if (days >= days2) {
          this.renouncementMessage += 'Rezilierea contractului nu va reactiva contractul vechi deoarece data rezilierii este dupa data intrarii in vigoare a contractului.';
        } else {
          this.renouncementMessage += 'Rezilierea contractului va reactiva contractul vechi (contractul a fost reziliat in termen de 14 zile fara ca acesta sa fi intrat in vigoare).';
        }
      }
    }
  }
}
